import { useState } from "react";
import styles from '../Settings/AppVersion.module.css'
import SuperUserUpdateUserAndPercentage from "./SuperUserUpdateUserAndPercentage";
import SuperUserTable from "./SuperUserTable";
import { useQuery } from "@apollo/client";
import { GET_ALL_SUPER_USERS } from "../AddTickets/api/addTicketsQuery";

const SuperUserUpdate = () => {
    const [page, setPage] = useState(0);
    const [resetEvent, setResetEvent] = useState(false)
    const [ticketDetails, setTicketDetails] = useState(null);
    const [search, setSearch] = useState(false);
    const [superUsersList, setSuperUsersList] = useState<any>([]);

     const {
        data:getAllSuperUsersData,
        loading: getAllSuperUsersLoading,
        error: getAllSuperUsersError,
        refetch: refetchSuperUsers
     } = useQuery(GET_ALL_SUPER_USERS, {
        fetchPolicy: 'no-cache',
        onCompleted: (data) => {       
            setSuperUsersList(data);
        },
        onError: (err) => {
            console.log(err)
        }
    })
    console.log("superUsersList in SuperUser Update tab:",superUsersList);
    
    return (
            <div className={styles.maindiv}>
                
                <div className={styles.seconddiv} style = { {width: '90%', gap: '0px'}}>
                    <SuperUserUpdateUserAndPercentage setSearch= {setSearch} setPage = {setPage} setTicketDetails = {setTicketDetails} ticketDetails = {ticketDetails} page = {page} resetEvent={resetEvent} setResetEvent = {setResetEvent} refetchData={refetchSuperUsers} setSuperUsersList = {setSuperUsersList}/>
                    <SuperUserTable loading={getAllSuperUsersLoading} setSuperUsersList = {setSuperUsersList} superUsersList = {superUsersList} refetchData={refetchSuperUsers}/>
                </div>
            </div>
    )
}

export default SuperUserUpdate;

